import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { Validators, FormControl, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as errorUtils from 'error-message-utility';
import * as i2 from 'sub-task-petition-details';
import * as i3 from 'reference-library';
import * as i4 from 'primeng/dropdown';
import * as i5 from '@angular/common';
import * as i6 from 'primeng/radiobutton';
import * as i7 from 'primeng/checkbox';
import { PrimengLibraryModule } from 'primeng-library';

class SubTaskExtraOrdinaryAbilityService {
    constructor() { }
}
SubTaskExtraOrdinaryAbilityService.ɵfac = function SubTaskExtraOrdinaryAbilityService_Factory(t) { return new (t || SubTaskExtraOrdinaryAbilityService)(); };
SubTaskExtraOrdinaryAbilityService.ɵprov = i0.ɵɵdefineInjectable({ token: SubTaskExtraOrdinaryAbilityService, factory: SubTaskExtraOrdinaryAbilityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskExtraOrdinaryAbilityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function SubTaskExtraOrdinaryAbilityComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SubTaskExtraOrdinaryAbilityComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "p-checkbox", 18);
    i0.ɵɵlistener("onChange", function SubTaskExtraOrdinaryAbilityComponent_div_23_Template_p_checkbox_onChange_1_listener($event) { i0.ɵɵrestoreView(_r5); const item_r2 = ctx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.updateCheckedOptions($event.checked, item_r2.code); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.extraOrdinaryAbilityForm.get("extrAblDocEvdCatgCode").value === ctx_r1.extraBLDOCEVDNCATGList[0].code)("formControlName", i_r3)("label", item_r2.description);
} }
class SubTaskExtraOrdinaryAbilityComponent {
    constructor(fb, apiService, referenceLibraryService, parentFor) {
        this.fb = fb;
        this.apiService = apiService;
        this.referenceLibraryService = referenceLibraryService;
        this.parentFor = parentFor;
        //serviceCenters: any[] = [];
        //reviewUsersList: any[] = [];
        //attorneys: any[] = [];
        //attorneyUsers: any[] = [];
        //users: any[] = [];
        //selectedSignatory: any;
        //selectedDesignation: any;
        //selectedPreparer: any;
        //selectedPetetionPreprarer: any;
        // questionAndResponseDTO: FormArray;
        // questionList: any[];
        // userType: string;
        // primaryCompanyId: number;
        // employeeDetails: any;
        // isAttorneySelect: boolean;
        // subTaskOverView: SubTask;
        // superTaskDetails: SuperTask;
        // petitionSubTaskDetails: SubTaskDetails;
        // taskId: any;
        // isOutsideImagility = true;
        // oldServiceCenterName: string;
        // oldAttorneyCompanyName: string;
        // oldPreparerAttorneyName: string;
        // petitionUpdates: boolean[] = [false, false];
        // visaType: string;
        // foreignCompanyList: any[] = [];
        // companyRelationList: ReferenceLibrary[] = [];
        this.fieldExtrAbltyCodeList = [];
        this.extraBLDOCEVDNCATGList = [];
        this.majorInternationAwardList = [];
        this.applicableOptionItem = [{
                code: String,
                name: String,
                description: String
            }];
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.extraOrdinaryAbilityForm = this.fb.group({
            fieldExtrAbltyCode: [null, Validators.required],
            extrAblDocEvdCatgCode: [null, Validators.required],
            applicableOptionIds: this.fb.array([]),
            applicableOptionCodes: this.fb.array([])
        });
        this.form = this.parentFor.form;
        this.form.addControl('extraOrdinaryAbilityForm', this.extraOrdinaryAbilityForm);
        // console.log(this.extraOrdinaryAbilityForm);
        if (this.extraOrdinaryAbilityForm) {
            for (const [key, value] of Object.entries(this.extraOrdinaryAbilityForm.controls)) {
                this.form.addControl(key, value);
            }
        }
        try {
            this.getExtraOrdinaryDetailsOVisa();
        }
        catch (error) {
            console.log("error", error);
        }
    }
    // get applicableOptionGroups() {
    //   return (this.extraOrdinaryAbilityForm.get('applicableOptionIds') as FormArray).controls;
    // }
    clickRadioBtn(extrAblDocEvdCatgCode) {
        this.extraOrdinaryAbilityForm.get('applicableOptionIds').patchValue(this.extraOrdinaryAbilityForm.get('applicableOptionIds').value.map((x, i) => {
            if (x) {
                this.updateCheckedOptions(false, this.majorInternationAwardList[i].code);
            }
            return false;
        }));
    }
    updateCheckedOptions(checked, code) {
        const applicableOptionIds = this.extraOrdinaryAbilityForm.get('applicableOptionCodes').value;
        if (checked) {
            if (!applicableOptionIds.includes(code)) {
                this.extraOrdinaryAbilityForm.get('applicableOptionCodes').push(new FormControl(code));
            }
        }
        else {
            if (applicableOptionIds.includes(code)) {
                this.extraOrdinaryAbilityForm.get('applicableOptionCodes').removeAt(applicableOptionIds.indexOf(code));
            }
        }
    }
    getExtraOrdinaryDetailsOVisa() {
        let fieldExtrAbltyCode;
        let payload;
        fieldExtrAbltyCode = 'O1BFLDEXTRABL';
        payload = ['OTHERDOCEVDN', 'O1BSPECDOCEVDN'];
        combineLatest([
            this.referenceLibraryService.getReferenceData('EXTRABLDOCEVDNCATG'),
            this.referenceLibraryService.postReferenceData(payload),
            this.referenceLibraryService.getReferenceData(fieldExtrAbltyCode)
        ]).pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
            // console.log(data);
            this.extraBLDOCEVDNCATGList = data[0];
            this.majorInternationAwardList = data[1];
            const applicableOptionIdsFormArray = this.extraOrdinaryAbilityForm.get('applicableOptionIds');
            applicableOptionIdsFormArray.clear();
            this.majorInternationAwardList.forEach(() => {
                applicableOptionIdsFormArray.push(new FormControl(false));
            });
            // console.log(applicableOptionIdsFormArray.value);
            this.fieldExtrAbltyCodeList = data[2];
            this.extraOrdinaryAbilityForm.patchValue({
                extrAblDocEvdCatgCode: this.extraBLDOCEVDNCATGList[0].code
            });
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    ngOnDestroy() {
        if (this.ngUnsubscribe) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
        }
    }
}
SubTaskExtraOrdinaryAbilityComponent.ɵfac = function SubTaskExtraOrdinaryAbilityComponent_Factory(t) { return new (t || SubTaskExtraOrdinaryAbilityComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.SubTaskPetitionDetailsService), i0.ɵɵdirectiveInject(i3.ReferenceLibraryService), i0.ɵɵdirectiveInject(i1.FormGroupDirective)); };
SubTaskExtraOrdinaryAbilityComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SubTaskExtraOrdinaryAbilityComponent, selectors: [["sub-task-extra-ordinary-ability-library"]], features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 24, vars: 7, consts: [["formGroupName", "extraOrdinaryAbilityForm", 1, "col-md-12", "p-mt-2"], [1, "p-grid"], [1, "p-col-9"], [1, "create-task-label", "question", "required"], ["name", "create-task-label question", 1, "p-col-12", "mb-2"], [1, "p-col-4"], ["formControlName", "fieldExtrAbltyCode", "name", "fieldExtrAbltyCode", "optionLabel", "name", "optionValue", "code", "placeholder", "Select field of extraordinary ability", 1, "extra-ordinary-dropdown", 3, "options"], ["class", "invalid-message", 4, "ngIf"], ["for", "tasktype", 1, "create-task-label", "question", "required"], [1, "p-col-12"], [1, "p-col-10"], ["name", "extrAblDocEvdCatgCode", "formControlName", "extrAblDocEvdCatgCode", "inputId", "extrAblDocEvdCatgCode0", 3, "value", "label", "click"], [1, "p-grid", "mt-2", "mb-2", "ml-1"], ["name", "extrAblDocEvdCatgCode", "formControlName", "extrAblDocEvdCatgCode", "inputId", "extrAblDocEvdCatgCode1", 3, "value", "label", "click"], [1, "p-grid", "mt-2", "mb-2"], ["class", "p-col-12", "formArrayName", "applicableOptionIds", 4, "ngFor", "ngForOf"], [1, "invalid-message"], ["formArrayName", "applicableOptionIds", 1, "p-col-12"], ["binary", "true", "name", "applicableOption", 3, "disabled", "formControlName", "label", "onChange"]], template: function SubTaskExtraOrdinaryAbilityComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "label", 3);
        i0.ɵɵtext(4, "Field of extraordinary ability ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 1);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelement(8, "p-dropdown", 6);
        i0.ɵɵtemplate(9, SubTaskExtraOrdinaryAbilityComponent_span_9_Template, 2, 1, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 2);
        i0.ɵɵelementStart(11, "label", 8);
        i0.ɵɵtext(12, "Applicable categories of Documentary Evidence");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵelementStart(14, "div", 1);
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵelementStart(16, "p-radioButton", 11);
        i0.ɵɵlistener("click", function SubTaskExtraOrdinaryAbilityComponent_Template_p_radioButton_click_16_listener() { return ctx.clickRadioBtn(ctx.extraBLDOCEVDNCATGList[0].code); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 12);
        i0.ɵɵtext(18, "Or");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 1);
        i0.ɵɵelementStart(20, "div", 9);
        i0.ɵɵelementStart(21, "p-radioButton", 13);
        i0.ɵɵlistener("click", function SubTaskExtraOrdinaryAbilityComponent_Template_p_radioButton_click_21_listener() { return ctx.clickRadioBtn(ctx.extraBLDOCEVDNCATGList[1].code); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 14);
        i0.ɵɵtemplate(23, SubTaskExtraOrdinaryAbilityComponent_div_23_Template, 2, 3, "div", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("options", ctx.fieldExtrAbltyCodeList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.extraOrdinaryAbilityForm.get("fieldExtrAbltyCode").touched && (ctx.extraOrdinaryAbilityForm.get("fieldExtrAbltyCode").errors == null ? null : ctx.extraOrdinaryAbilityForm.get("fieldExtrAbltyCode").errors.required));
        i0.ɵɵadvance(7);
        i0.ɵɵpropertyInterpolate("label", ctx.extraBLDOCEVDNCATGList[0].desc);
        i0.ɵɵproperty("value", ctx.extraBLDOCEVDNCATGList[0].code);
        i0.ɵɵadvance(5);
        i0.ɵɵpropertyInterpolate("label", ctx.extraBLDOCEVDNCATGList[1].desc);
        i0.ɵɵproperty("value", ctx.extraBLDOCEVDNCATGList[1].code);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.majorInternationAwardList);
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupName, i4.Dropdown, i1.NgControlStatus, i1.FormControlName, i5.NgIf, i6.RadioButton, i5.NgForOf, i1.FormArrayName, i7.Checkbox], styles: ["./sub-task-extra-ordinary-ability.component.scss"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskExtraOrdinaryAbilityComponent, [{
        type: Component,
        args: [{
                selector: 'sub-task-extra-ordinary-ability-library',
                templateUrl: 'sub-task-extra-ordinary-ability.component.html',
                styles: ['./sub-task-extra-ordinary-ability.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ]
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.SubTaskPetitionDetailsService }, { type: i3.ReferenceLibraryService }, { type: i1.FormGroupDirective }]; }, null); })();

class SubTaskExtraOrdinaryAbilityModule {
}
SubTaskExtraOrdinaryAbilityModule.ɵfac = function SubTaskExtraOrdinaryAbilityModule_Factory(t) { return new (t || SubTaskExtraOrdinaryAbilityModule)(); };
SubTaskExtraOrdinaryAbilityModule.ɵmod = i0.ɵɵdefineNgModule({ type: SubTaskExtraOrdinaryAbilityModule });
SubTaskExtraOrdinaryAbilityModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SubTaskExtraOrdinaryAbilityModule, { declarations: [SubTaskExtraOrdinaryAbilityComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [SubTaskExtraOrdinaryAbilityComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubTaskExtraOrdinaryAbilityModule, [{
        type: NgModule,
        args: [{
                declarations: [SubTaskExtraOrdinaryAbilityComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [SubTaskExtraOrdinaryAbilityComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of sub-task-extra-ordinary-ability
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SubTaskExtraOrdinaryAbilityComponent, SubTaskExtraOrdinaryAbilityModule, SubTaskExtraOrdinaryAbilityService };
//# sourceMappingURL=sub-task-extra-ordinary-ability.js.map
